/* app/js/src/components/graphics/edit/fields/color.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.container .label {
  margin-top: 14.5px;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
/*# sourceMappingURL=color.component.css.map */
